
/*
jedinica mere za radna vremena je minuta
 
angazovanihradnika - je broj koliko radnika koji izvrsavaju operaciju.
Napomena: vremena se ne mnoze sa brojem radnika jer je u vreme operaciej vec uracunato vreme za sve angazovane radnike. Na primer ukoliko je angazovane dva radnika u vreme operaciej je vec uracunato vreme za obojicu.
 
vremepripreme - je vreme koliko je potrebno da se sam poluproizvod pripremi ali za sada je to vreme uracunato u vreme operacije

vremeoperacije - je vreme koliko traje operacija

vremeugradnje - je vreme koliko se ovaj popluproizvod ugradjuje u sledeci poluproizvod viseg nivoa
// ovo se verovatno koristi za izracnavanje vremeoperacije sledeceg elementa iznad njega

vremekumulativno - je kumulativno utroseno vreme za sam element i sve nize nivoe koji cine njega

vremeopsklapanje - je samo za one virtele kod kojih je operacije === "OP-Sklapanje" i ona se dobija racunanjem od vremeugradnje njegovih childrena.

*/


// SIFRARNIK JEDINICA
export const terLibSifrarnikJedinice = {
  "kom": "kom",
  "m": "m",
  "mm": "mm",
  "m2": "m2",
  "m3": "m3",
  "kg": "kg"
};

// SIFRARNIK OPERACIJA
export const terLibSifrarnikOp = {
  "OPNISTA": "OP-NISTA",
  "OPSKUP": "OP-SKUP",
  "OPSKL": "OP-Sklapanje",
  "OPOBR": "OP-Obrada",
  "OPSEC": "OP-Secenje",
  "OPSAV": "OP-Savijanje",
  "OPZAV": "OP-Zavarivanje",
  "OPFRZ": "OP-Frezenkovanje",
  "OPLEP": "OP-Lepljenje"
};

// SIFRARRNIK RADNI CENTRI RESURSI
export const terLibSifrarnikRadniCentri = {
  "RCBEZRESURSA": "Bez resursa", // NOVO 2024-07-09
  "RCNISTA": "NISTA", // NOVO 2023-11-15
  "RCVC": "RC-Vcut",
  "RCTP": "RC-Testera Petrici",
  // "RCERM": "RC-Ermaksan", // 2023-06-27 IZBRISAN DUPLIKAT, KORTSICEMO RCPRSER
  "RCPRSER": "RC-Presa Ermaksan", // NOVO PROVERITI
  "RCGT22": "RC-Grigio T22",
  "RCHOL": "RC-HolzHer",
  "RCNNM": "RC-Nanomatic",
  "RCPOL": "RC-Polar",
  "RCPRBAM": "RC-Probijacica Amada", // NOVO PROVERITI
  "RCPRBS4": "RC-Probijacica S4",
  "RCSAVP4": "RC-Savijacica P4",
  "RCLINS4P4": "RC-Linija S4+P4",
  "GRCFIN": "GRC-Finalizacija",
  "RCZAV": "RC-Zavarivanje",
  "RCPANCS": "RC-Paneli CS",
  "GRCPANKK": "GRC-Paneli KK",
  "RCVRAKK": "RC-Vrata KK",
  "RCDE": "RC-Distributivni elementi",
  // "RCPRIG": "RC-Prigusivaci",
  "RCPOS": "RC-Postolja",
  // NOVI 2024-09-01
  "RCGOTP": "RC-Gotovi proizvodi",
  "RCKLI": "RC-Klizaci",
  "RCPRB": "RC-Prigusivaci buke", // ???
  "RCPAL": "RC-Palete", // ???
};




// SIFRARNIK/PARAMETRI MATERIJALI
// ID Grupa	Kategorija Ident Naziv Tip J.m Aktivan Napomena
// export const terLibParametriMaterijaliPrvi = { // ne exportujem da znam da se ne koristi vise
const terLibParametriMaterijaliPrvi = {
  "PRF063": {
    "naziv": "",
    "tergrupa": "elasticnaveza",
    "kategorije": "PROFIL", // ???
    "ident": "PM20DDA000005000",
    "naziv": "PROFIL GS METZ HV20 DPS M20D SIROV",
    "tip": "HV20",
    "jm": "m",
    "aktivan": true,
    "lib_note": "",
  },
  "ROG064": {
    "naziv": "",
    "tergrupa": "elasticnaveza",
    "kategorije": "ROGALJ", // ???
    "ident": "A030020000000001",
    // "naziv": "ROGALJ POCINKOVANI UGAO METZ 20 DPS	METZ30",
    "naziv": "ROGALJ POCINKOVANI UGAO METZ 20 DPS",
    "tip": "METZ20",
    "jm": "kom",
    "aktivan": true,
    "lib_note": "",
  },
  "PRF065": {
    "naziv": "",
    "tergrupa": "elasticnaveza",
    "kategorije": "PROFIL", // ???
    // "ident": "PM30DDA000005000",
    "ident": "PM30DDA00000",
    "naziv": "PROFIL GS METZ HV30 DPS M30D SIROV",
    "tip": "HV30",
    "jm": "m",
    "aktivan": true,
    "lib_note": "",
  },
  "ROG066": {
    "naziv": "",
    "tergrupa": "elasticnaveza",
    "kategorije": "ROGALJ", // ???
    "ident": "A030020000000002",
    "naziv": "ROGALJ POCINKOVANI UGAO METZ 30 DPS",
    "tip": "METZ30",
    "jm": "kom",
    "aktivan": true,
    "lib_note": "",
  },
  "PLT067": {
    "naziv": "",
    "tergrupa": "elasticnaveza",
    "kategorije": "PLATNO", // ???
    "ident": "A040000000000019",
    "naziv": "TRAKA FLEKSI VEZA DPS 130mm",
    "tip": "",
    "jm": "m",
    "aktivan": true,
    "lib_note": "",
  },
  "PLT068": {
    "naziv": "",
    "tergrupa": "elasticnaveza",
    "kategorije": "PLATNO", // ???
    "ident": "A040000000000005",
    "naziv": "TRAKA FLEKSI VEZA FIB.GL/PU 45/60/45",
    "tip": "",
    "jm": "m",
    "aktivan": true,
    "lib_note": "",
  },
  "PLT069": {
    "naziv": "",
    "tergrupa": "elasticnaveza",
    "kategorije": "PLATNO", // ???
    "ident": "A040000000000018",
    "naziv": "TRAKA FLEKSI VEZA TOPLJIVA DPS 21mm",
    "tip": "",
    "jm": "m",
    "aktivan": true,
    "lib_note": "",
  }
};




// VIRTEL PARAMS

// export const terLibVirtelParametri = { // ne exportujem da znam da se ne koristi vise
const terLibVirtelParametri = {

  "terkk$klimakomora": {
    "virtelclass": "terkk$klimakomora",
    "terkategorija": "PP",
    "tergrupa": "AHU",
    "operacija": "OPSKL",
    "rc": "GRCFIN",
    "jm": "kom",
  },

  "terkk$modul": {
    "virtelclass": "terkk$modul",
    "terkategorija": "PP",
    "tergrupa": "MODUL",
    "operacija": "OPSKL",
    "rc": "GRCFIN",
    "kolicina": 1, // Broj komada modula je uvek 1 po jednom komadu klima komore
    "jm": "kom",
  },

  "terkk$modul$rogalj": {
    "virtelclass": "terkk$modul$rogalj",
    "terkategorija": "M",
    "tergrupa": null,
    "kolicina": 8, // Broj komada rogljeva je uvek 8 po jednom komadu modula
    "jm": "kom",
  },

  "terkk$profilosnovni": {
    "virtelclass": "terkk$profilosnovni",
    "terkategorija": "PP",
    "tergrupa": "PROFIL",
    "operacija": "OPSEC",
    "rc": "RCVC",
    "angazovanihradnika": 1,
    "vremepripreme": 0,
    "vremeoperacije": 2,
    "vremeugradnje": 3,
    "jm": "kom",
    "leviger": 90,
    "desniger": 90,
  },

  "terkk$profilpregradni_op_obrada": {
    "virtelclass": "terkk$profilpregradni_op_obrada",
    "terkategorija": "PP",
    "tergrupa": "PROFIL",
    "operacija": "OPOBR",
    "rc": "RCPOL",
    "angazovanihradnika": 1,
    "vremepripreme": 0,
    "vremeoperacije": 2,
    "vremeugradnje": 3,
    "jm": "kom",
    "leviger": 90,
    "desniger": 90,
  },

  "terkk$profilpregradni_op_secenje": {
    "virtelclass": "terkk$profilpregradni_op_secenje",
    "terkategorija": "PP",
    "tergrupa": "PROFIL",
    "operacija": "OPSEC",
    "rc": "RCVC",
    "angazovanihradnika": 1,
    "vremepripreme": 0,
    "vremeoperacije": 2,
    "vremeugradnje": 0,
    "jm": "kom",
    "leviger": 90,
    "desniger": 90,
  },


  "terkk$panel_tip_not_vrata": {
    "virtelclass": "terkk$panel_tip_not_vrata",
    "_readme": "panel kada tip panela nije vrata",
    "operacija": "OPSKL",
    "rc": "GRCPANKK",
    "angazovanihradnika": 2,
    "vremepripreme": 0,
    "vremeoperacije": 10,
    "vremeugradnje": 6,
    "jm": "kom",
  },
  "terkk$panel_tip_vrata": {
    "virtelclass": "terkk$panel_tip_vrata",
    "_readme": "panel kada je tip panela vrata",
    "operacija": "OPSKL",
    "rc": "RCVRAKK",
    "angazovanihradnika": 1,
    "vremepripreme": 0,
    "vremeoperacije": 0,
    "vremeugradnje": 6,
    "jm": "kom",
  },
  "terkk$panel_tip_vrata$op_pre_vrata": {
    "virtelclass": "terkk$panel_tip_vrata$op_pre_vrata",
    "_readme": "panel jedna operacija pre sklapanja panela tipa vrata",
    "terkategorija": "PP",
    "tergrupa": "PANEL",
    "operacija": "OPSKL",
    "rc": "GRCPANKK",
    "angazovanihradnika": 2,
    "vremepripreme": 0,
    "vremeoperacije": 10,
    "vremeugradnje": 6,
    "jm": "kom",
  },
  "terkk$panel$profil": {
    "virtelclass": "terkk$panel$profil",
    "terkategorija": "PP",
    "tergrupa": "PROFIL",
    "operacija": "OPSEC",
    "rc": "RCTP",
    "angazovanihradnika": 1,
    "vremepripreme": 0,
    "vremeoperacije": 2,
    "vremeugradnje": 0,
    "jm": "kom",
    "leviger": 90, // ???
    "desniger": 90, // ???
    "leviger": 45,
    "desniger": 45,
  },
  "terkk$panel$lim_spoljasnji": {
    "virtelclass": "terkk$panel$lim_spoljasnji",
    "terkategorija": "PP",
    "tergrupa": "LIM",
    "operacija": "OPSEC",
    "rc": "RCLINS4P4",
    "angazovanihradnika": 2,
    "vremepripreme": 0,
    "vremeoperacije": 2.5,
    "vremeugradnje": 0,
    "jm": "kom",
  },
  "terkk$panel$lim_unutrasnji": {
    "virtelclass": "terkk$panel$lim_unutrasnji",
    "terkategorija": "PP",
    "tergrupa": "LIM",
    "operacija": "OPSEC",
    "rc": "RCLINS4P4",
    "angazovanihradnika": 2,
    "vremepripreme": 0,
    "vremeoperacije": 2.5,
    "vremeugradnje": 0,
    "jm": "kom",
  },
  "terkk$panel$ojacanje": {
    "virtelclass": "terkk$panel$ojacanje",
    "terkategorija": "PP",
    "tergrupa": "LIM",
    "operacija": "OPSEC",
    "rc": "RCLINS4P4",
    "angazovanihradnika": 2,
    "vremepripreme": 0,
    "vremeoperacije": 2.5,
    "vremeugradnje": 0,
    "jm": "kom",
    // cncprogram1: "Lim AHU Panel Ojacanje.S4",
  },
  "terkk$panel$ispuna": { // kamena vuna ili poliuretan
    "virtelclass": "terkk$panel$ispuna",
    "terkategorija": "PP",
    "tergrupa": "ISPUNA",
    "operacija": "OPSEC",
    "rc": "RCHOL",
    "angazovanihradnika": 1,
    "vremepripreme": 0,
    "vremeoperacije": 2.3,
    "vremeugradnje": 0,
    "jm": "kom",
  },
  "terkk$panel$panel_novo_rucica_m": {
    "virtelclass": "terkk$panel$panel_novo_rucica_m",
    "readme": "materijal2",
    "terkategorija": "M",
    "vremeugradnje": 5,
  },
  "terkk$panel$sigurnosnabrava": {
    "virtelclass": "terkk$panel$sigurnosnabrava",
    "readme": "Materijal",
    "terkategorija": "M",
    "vremeugradnje": 0,
  },


  "terkk$demper": {
    "virtelclass": "terkk$demper",
    "terkategorija": "PP",
    "operacija": "OPSKL",
    "rc": "RCDE",
    "angazovanihradnika": 1,
    "vremepripreme": 0,
    "vremeoperacije": 20,
    "vremeugradnje": 10
  },
  "terkk$demper$profil": {
    "virtelclass": "terkk$demper$profil",
    "terkategorija": "PP",
    "tergrupa": "PROFIL",
    "operacija": "OPSEC",
    "rc": "RCTP",
    "angazovanihradnika": 1,
    "vremepripreme": 0,
    "vremeoperacije": 2,
    "vremeugradnje": 0,
    "jm": "kom",
    "leviger": 90,
    "desniger": 90,
  },

  "terkk$elasticnaveza": {
    "virtelclass": "terkk$elasticnaveza",
    "operacija": "OPSKL",
    "rc": "RCDE",
    "angazovanihradnika": 1,
    "vremepripreme": 0,
    "vremeoperacije": 20,
    "vremeugradnje": 10
  },
  "terkk$elasticnaveza$profil": {
    "virtelclass": "terkk$elasticnaveza$profil",
    "terkategorija": "PP",
    "tergrupa": "PROFIL",
    "operacija": "OPSEC",
    "rc": "RCDE",
    "angazovanihradnika": 1,
    "vremepripreme": 0,
    "vremeoperacije": 2,
    "vremeugradnje": 0,
    "jm": "kom",
    "leviger": 90,
    "desniger": 90,
  },

  "terkk$eliminatorkapi": {
    "virtelclass": "terkk$eliminatorkapi",
    "terkategorija": "PP",
    "tergrupa": "eliminatorkapi",
    "operacija": "OPSKL",
    "rc": "RCDE",
    "angazovanihradnika": 1,
    "vremepripreme": 0,
    "vremeoperacije": 20,
    "vremeugradnje": 5,
    "jm": "kom",
  },
  "terkk$eliminatorkapi$profil": {
    "virtelclass": "terkk$eliminatorkapi$profil",
    "terkategorija": "PP",
    "tergrupa": "PROFIL",
    "operacija": "OPSEC",
    "rc": "RCTP",
    "angazovanihradnika": 1,
    "vremepripreme": 0,
    "vremeoperacije": 2,
    "vremeugradnje": 0,
    "jm": "kom",
    "leviger": 90,
    "desniger": 90,
  },

  "terkk$spoljnafiksnazaluzina": {
    "virtelclass": "terkk$spoljnafiksnazaluzina",
    "terkategorija": "PP",
    "tergrupa": "spoljnafiksnazaluzina",
    "operacija": "OPSKL",
    "rc": "RCDE",
    "angazovanihradnika": 1,
    "vremepripreme": 0,
    "vremeoperacije": 20,
    "vremeugradnje": 10,
    "jm": "kom",
  },
  "terkk$spoljnafiksnazaluzina$profil": {
    "virtelclass": "terkk$spoljnafiksnazaluzina$profil",
    "terkategorija": "PP",
    "tergrupa": "PROFIL",
    "operacija": "OPSEC",
    "rc": "RCTP",
    "angazovanihradnika": 1,
    "vremepripreme": 0,
    "vremeoperacije": 2,
    "vremeugradnje": 0,
    "jm": "kom",
    "leviger": 90,
    "desniger": 90,
  },

  "terkk$kadica": {
    "virtelclass": "terkk$kadica",
    "terkategorija": "PP",
    "tergrupa": "KADICA",
    "operacija": "OPZAV",
    "rc": "RCZAV",
    "angazovanihradnika": 1,
    "vremepripreme": 0,
    "vremeoperacije": 10,
    "vremeugradnje": 15,
  },
  "terkk$kadica.1": { // kadica_op_druga
    "virtelclass": "terkk$kadica.1",
    "terkategorija": "PP",
    "tergrupa": "KADICA",
    "operacija": "OPSAV",
    "rc": "RCPRSER",
    "angazovanihradnika": 1,
    "vremepripreme": 0,
    "vremeoperacije": 5,
    "vremeugradnje": 0,
  },
  "terkk$kadica.1.1": { // kadica_op_prva
    "virtelclass": "terkk$kadica.1.1",
    "terkategorija": "PP",
    "tergrupa": "LIM", // Kod kadice red kadica.1.1 treba da ima vrednost u koloni "Grupa" umesto KADICA da stoji LIM.
    "operacija": "OPSEC",
    "rc": "RCPRBAM",
    "angazovanihradnika": 1,
    "vremepripreme": 0,
    "vremeoperacije": 3,
    "vremeugradnje": 0,
  },
  "terkk$kadica$materijal_lim": {
    "virtelclass": "terkk$kadica$materijal_lim",
    "terkategorija": "M",
    // "tergrupa": "LIM", // ne treba grupa za materijal
    "ident": "LC00000J",
    // "naziv": "LIM SS 1.50 mm",
    "naziv": "LIM PROHROM 1.50",
    "tip": "", // TODO ???
    "jm": "m2",
  },

  /*
  "terkk$postolje": {
    "tergrupa": "POSTOLJE",
    "operacija": "OPZAV",
    "rc": "RCZAV",
    "angazovanihradnika": 1,
    "vremepripreme": 0,
    "vremeoperacije": 0,
    "vremeugradnje": 0,
    "lib_note": "ne koristimo terkk$postolje nego se postolje$profil direktno ugradjuju u modul"
  },
  */
  "terkk$postolje$profil": {
    "virtelclass": "terkk$postolje$profil",
    "terkategorija": "PP",
    "tergrupa": "LIM",
    "operacija": "OPSEC",
    "rc": "RCLINS4P4",
    "angazovanihradnika": 1,
    "vremepripreme": 0,
    "vremeoperacije": 0,
    "vremeugradnje": 0,
  },
  "terkk$postolje$profil_niski": {
    "virtelclass": "terkk$postolje$profil_niski",
    "terkategorija": "PP",
    "tergrupa": "LIM",
    "operacija": "OPSAV",
    "rc": "RCPRSER",
    "angazovanihradnika": 1,
    "vremepripreme": 0,
    "vremeoperacije": 0,
    "vremeugradnje": 0,
  },
  "terkk$postolje$profil_niski.1": {
    "virtelclass": "terkk$postolje$profil_niski.1",
    "terkategorija": "PP",
    "tergrupa": "LIM",
    "operacija": "OPSEC",
    "rc": "RCLINS4P4",
    "angazovanihradnika": 1,
    "vremepripreme": 0,
    "vremeoperacije": 0,
    "vremeugradnje": 0,
  },
};

/*
U prilogu je nove sastavnica sa dodatim poluproizvodima.

Elasticna veza - FLEXI CONNECTION
Demper – DAMPER
Eliminator kapi - DROP ELIMINATOR
Spoljna fiksna žaluzina - AIR LOUVER



Objasnjenje parametra mozes naci u dokumentu SASTAVNICA-BOM-Rev_5 saljem ga opet u prilogu.

Ovaj primer mozes da testiras preko narudzbine kupca broj 2101OR0000770 company_filekey: 5407
*/


/*
panel_tip_vrata

jm                                kom
operacija                     OPSKL
rc                                 RCVRAKK
angazovanihradnika   1
vremepripreme           0
vremeoperacije           Proracunava se u odnusu na broj elemenata i njihovih vremena za ugradnju (spisak ispod)
vremeugradnje           6



B100010000000049    OSTALO REVIZIONI OTVOR W 39-53                                                             - 4 min/kom

B080010000000004    RUČICA PVC KLIMAFLEX 2 2651-205400 INDUSTRILAS                                - 1,5 min/kom

B080010000000008    RUČICA PVC KLIMAFLEX 2 2651-215690 INDUSTRILAS SA KLJUCEM          - 1,5 min/kom

B080010000000007    ŠARKA PVC KLIMAFLEX 325070 INDUSTRILAS                                              - 1 min/kom

B100000000000028    OSTALO SIGURNOSNA BRAVA T=50 mm                                                      - 1 min /kom
*/



// BAZA VENTILATORA PROBNA NOVO KLADOVO 2023 MAJ
// SIFRARNIK/PARAMETRI MATERIJALI
// ID Grupa	Kategorija Ident Naziv Tip J.m Aktivan Napomena
const terLibVentilatoriProbni = { // ne exportujem da znam da se ne koristi vise
  "ER28C": {
    "lib_note": "",
    Ident: "IDENT3",
    Ventilator: "ER28C - 3 kW",
    Tip_Ventilatora: "ER28C",
    Snaga_motora: 3,
    Masa_kg: 39,
    Visina_amortizera: 30,
    Amortizeri: "40x30",
    Broj_Amortizera: 4,
    Visina_nosaca: 30,
    Broj_otvora_za_el_vezu: 4,
    Rastojanje_izmedju_otvora_el_veze_o1: 300,
    // Rastojanje_otvora_srednjih_12_otvora_o2: null,
    Rastojanje_otvora_srednjih_12_otvora_o2: 0,
    Visina_do_ose_vratila_radnog_kola: 215,
    Otvor_na_nosaču_za_zavrtanj_amortizera: 11,
    Nosac_ventilatora: "DA",
  },
  "ER90C": {
    "lib_note": "",
    Ident: "IDENT9",
    Ventilator: "ER90C - 22 kW",
    Tip_Ventilatora: "ER90C",
    Snaga_motora: 22,
    Masa_kg: 430,
    Visina_amortizera: 50,
    Amortizeri: "75x50",
    Broj_Amortizera: 4,
    Visina_nosaca: 45,
    Broj_otvora_za_el_vezu: 12,
    Rastojanje_izmedju_otvora_el_veze_o1: 950,
    Rastojanje_otvora_srednjih_12_otvora_o2: 400,
    Visina_do_ose_vratila_radnog_kola: 674,
    Otvor_na_nosaču_za_zavrtanj_amortizera: 13,
    Nosac_ventilatora: "DA",
  },
  "GR56": {
    "lib_note": "",
    Ident: "IDENT12",
    Ventilator: "GR56",
    Tip_Ventilatora: "GR56",
    Snaga_motora: null,
    Masa_kg: null,
    Visina_amortizera: null,
    Amortizeri: null,
    Broj_Amortizera: 0,
    Visina_nosaca: null,
    Broj_otvora_za_el_vezu: 12,
    Rastojanje_izmedju_otvora_el_veze_o1: 662,
    Rastojanje_otvora_srednjih_12_otvora_o2: 250,
    Visina_do_ose_vratila_radnog_kola: null,
    Otvor_na_nosaču_za_zavrtanj_amortizera: null,
    Nosac_ventilatora: "NE",
  },
};


//
export const terLibTerkkCparamsDefaultOld = {
  terkk_consts_number: {
    //
    KOLIKO_DECIMALA_UTROSAK_DEFAULT_M: 3,
    KOLIKO_DECIMALA_UTROSAK_DEFAULT_M2: 2,
    KOLIKO_DECIMALA_UTROSAK_LIMA_M2: 2,
    KOLIKO_DECIMALA_UTROSAK_KAMENE_VUNE_M2: 2,
    KOLIKO_DECIMALA_UTROSAK_PROFILA_M: 2,
    //
    panel_SIRINA_TABLE_VUNE: 1200,
    panel_VISINA_TABLE_VUNE: 2000,
    panel_MAX_SIRINA_ISECENE_VUNE: 1200,
    panel_MAX_VISINA_ISECENE_VUNE: 2000,
    panel_ZAZOR_VUNE: 0,
    panel_ZAZOR_VUNE_SLUCAJ_VRATA: 1, // ???
    //
    prbkulisa_DUZINA_TABLE_VUNE: 1000,
    prbkulisa_VISINA_TABLE_VUNE: 600,
    prbkulisa_DEBLJINA_TABLE_VUNE: 50,
    prbkulisa_MAX_DUZINA_ISECENE_VUNE: 1000,
    prbkulisa_MAX_VISINA_ISECENE_VUNE: 600,
    prbkulisa_MIN_DIMENZIJA_ISECNE_VUNE: 100,
    //
    kadica_MIN_DIMENZIJA_PRI_PODELI: 150,
  },
  terkk_consts_string: {
    EXAMPLE: "example",
  },
  terkk_materijal_ident: {
    // panel
    panel_materijal_lim_default: "LBMAU00A", // default
    panel_materijal_lim_spoljasnji: "LBMAU00A", // spoljasni lim uvek isti tip // isto kao default
    panel_materijal_lim_unutrasnji_redovni: "LBMAU00A", // Svi sem podnog // isto kao default
    panel_materijal_lim_unutrasnji_redovni_podni: "LBJAR00D", //
    panel_materijal_lim_unutrasnji_hygiene_prohrom: "LC00000A",
    panel_materijal_lim_unutrasnji_hygiene_plastificirani: "LBMAU00A", // isto kao default
    panel_materijal_lim_unutrasnji_hygiene_podni: "LC00000D",
    panel_materijal_kamenavuna: "IAGIA45",
    panel_materijal_poliuretan: "IFF0030A0045",
    // kadica
    kadica_materijal_lim_default: "LC00000J",
    // klizac
    klizactipa_materijal_lim_pocinkovani: "LB00000J",
    klizactipa_materijal_lim_prohrom: "LC00000J",
    klizactipb_materijal_lim_pocinkovani: "LB00000J",
    klizactipb_materijal_lim_prohrom: "LC00000J",
    klizactipc_materijal_lim_pocinkovani: "LB00000J",
    klizactipc_materijal_lim_prohrom: "LC00000J",
    klizactipc_materijal_lim_plocica: "LC00000K",
    klizactipc_materijal_profil: "P4040EA000C06000",
    // prigusivacbuke
    prbkulisa_materijal_kamenavuna: "A060000000000003",
    prbkulisa_materijal_lim_pocinkovani: "LB00000D",
    prbkulisa_materijal_lim_prohrom: "LC00000D",
    prbnosac_materijal_lim_pocinkovani: "LB00000J",
    prbnosac_materijal_lim_prohrom: "LC00000J",
  },
  test_1: {
    a: true,
    b: false,
    test_1_1: {
      test_1_1_1: {
        c: 'test_1_1_1 c',
        d: 'test_1_1_1 d',
      }
    },
  },
  old: "this is old",
};

